import { useParams } from "react-router-dom";
import Title from '../components/Title';
import Post from "../components/news/posts/Post";
import Categories from "../components/news/widgets/Categories";
import RecentNews from "../components/news/widgets/RecentNews";
import useCache from '../hooks/use-cache';
import '../resources/css/post.css';
import { useGetPostQuery } from '../store';

export default function PostPage() {

    const { id } = useParams();
    const cacheKey = `post-${id}`;
    const { data } = useCache(cacheKey, useGetPostQuery, id);

    return (
        <>
            {data && <div>
                <Title value={data.title}></Title>

                <div className="news-container">
                    <Post data={data}></Post>

                    <div className="post-widgets">
                        <RecentNews></RecentNews>
                        <Categories></Categories>
                    </div>
                </div>

            </div>}
        </>
    );
};